export const creditCardLimitChange = {
    displayBalance: true,
    displayDrawnAmount: true,
};
